// Syncs the client i18next instance to the locale detected server-side by the
// i18next middleware (passed down via root loader data). This is the documented
// remix-i18next v8 approach. cf. https://sergiodxa.github.io/remix-i18next/

import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

export function useChangeLanguage(locale: string) { 
  const { i18n } = useTranslation()
  useEffect(() => { 
    i18n.changeLanguage(locale)
  }, [locale, i18n])
} 